<template>
  <div class="g-image-carousel">
    <v-flex class="text-xs-right">
      <a id="fb-share-button" @click="shareIt()">
        <svg viewBox="0 0 12 12" preserveAspectRatio="xMidYMid meet">
          <path class="svg-icon-path" d="M9.1,0.1V2H8C7.6,2,7.3,2.1,7.1,2.3C7,2.4,6.9,2.7,6.9,3v1.4H9L8.8,6.5H6.9V12H4.7V6.5H2.9V4.4h1.8V2.8 c0-0.9,0.3-1.6,0.7-2.1C6,0.2,6.6,0,7.5,0C8.2,0,8.7,0,9.1,0.1z"></path>
        </svg>
        <span>{{$t('products.share')}}</span>
      </a>
    </v-flex>
    <v-layout>
      <v-flex>
        <v-card>
            <swiper :options="swiperOptionTop" class="gallery-top" :class="((!$props.images) || $props.images.length === 0) && 'gallery-top-default-img'" ref="swiperTop">
              <v-list-tile-avatar class="compInfo" v-if="$props.compUser && $props.compUser[0]">
                <router-link :to="'/accounts/' + $props.compUser[0].id" class="prouduct-avatar">
                  <img class="ml-3" v-if="$props.compUser[0].image" :src="`${ROOT_API}${$props.compUser[0].image}`" alt="User image">
                                    <i v-else class="material-icons">
                                      account_circle
                                    </i>
                  <p class="show-text"> {{$props.compUser[0].firstName}}</p>
                </router-link>
              </v-list-tile-avatar>
              <swiper-slide class="default-img" v-if="(!$props.images) || $props.images.length === 0" :style="{backgroundImage: 'url(' + require('../../assets/images/image-icon.svg')+ ')' }" />
              <template v-else>
                <swiper-slide class="swiper-slide" v-for="(image,i) in  $props.images" :key="i" :style="{backgroundImage: 'url(' + ROOT_API + image['lg'] + ')'}"/>
              </template>
            </swiper>
            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs" v-show="$props.images && $props.images.length > 1">
              <swiper-slide class="slide-1" v-for="(image,i) in  $props.images" :key="i" :style="{backgroundImage: 'url(' + ROOT_API + image['lg'] + ')'}"/>
            </swiper>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  components: {
  },
  name: 'ImageCarousel',
  props: ['images', 'generalImage', 'product', 'compUser'],
  data: () => ({
    docUrl: document.URL,
    imgSrc: '',
    activeImage: 0,
    ROOT_API: process.env.ROOT_API,
    cycleImages: false,
    swiperOption: {
      controls: 'hidden',
      direction: 'horizontal',
      effect: 'fade',
      touch: true
    },
    swiperOptionTop: {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    },
    swiperOptionThumbs: {
      spaceBetween: 10,
      centeredSlides: true,
      // slidesPerView: 'auto',
      touchRatio: 0.2,
      slidesPerView: 4,
      slideToClickedSlide: true,
      paginationClickable: true
    }
  }),
  methods: {
    activateImage (imageIndex) {
      this.activeImage = imageIndex
    },
    methodX () {
      return [this.$refs.swiperTop.swiper.activeIndex, this.$refs.swiperThumbs.swiper.activeIndex]
    },
    shareIt () {
      let url = encodeURIComponent(process.env.ROOT_API + '/api/product/shareOnFB/' + this.product.id + '/' + localStorage.getItem('lang'))
      window.open('http://www.facebook.com/sharer.php?u=' + url, '', 'width=500, height=500, scrollbars=yes, resizable=no')
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      swiperTop.slideTo(this.activeImage, 0, true)
      if (this.$refs.swiperThumbs) {
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperThumbs.controller.control = swiperTop
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.slideTo(this.activeImage, 0, true)
      }
    })
  },
  created () {
    if (this.$props.images) {
      this.$props.images.forEach((img, i) => {
        if (img['original'] === this.$props.generalImage) {
          this.activeImage = i
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  #fb-share-button {
    background: linear-gradient(76deg,#46CBE2,#652AD7 185%);
    border-radius: 3px;
    font-weight: 600;
    padding: 5px 8px;
    display: inline-block;
    position: static;
  }

  #fb-share-button:hover {
    cursor: pointer;
    background: linear-gradient(76deg,#46CBE2,#652AD7 120%);
  }

  #fb-share-button svg {
    width: 18px;
    fill: white;
    vertical-align: middle;
    border-radius: 2px
  }

  #fb-share-button span {
    vertical-align: middle;
    color: white;
    font-size: 14px;
    padding: 0 3px
  }
  @import "../../assets/sass/desktop/imagecarousel.scss";
  .gallery-top-default-img {
    & /deep/ .swiper-wrapper {
      justify-content: center;
      /*transform: none !important;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/products/imageCarousel.vue